import React, { Component } from 'react';
import { Button } from '@blueprintjs/core';
import ReactSelectAsyncContainer from '../../reactSelectWrappers/ReactSelectAsyncContainer';

class PMBPSearch extends Component {

	render() {
		const p = this.props;
		return (
			<div>
				<span>BP</span>
				<ReactSelectAsyncContainer
					queryName={'BP.CompanySelectSearch'}
					attr={'company'}
					typeName={'company'}
					focus={true}
					querySearch={false}
					minimumAttributeLength={2}
					onChange={p.selectBPFromSearch}
					returnObj={{ attr: 'cardCode' }}
				/>
			</div>
		);
	}
}
export default PMBPSearch;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/PMBPSearch.js